var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClockIcon = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.141,
    height: 24.141,
    viewBox: "0 0 24.141 24.141",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff8902;stroke:#ff8902;stroke-width:0.8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.7 -6.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.77,7.1a11.67,11.67,0,1,0,11.67,11.67A11.642,11.642,0,0,0,18.77,7.1Zm0,22.075a10.4,10.4,0,1,1,10.4-10.4A10.442,10.442,0,0,1,18.77,29.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.537,23.48H31.912V17.856a.656.656,0,0,0-1.312,0v6.28a.641.641,0,0,0,.656.656h6.28a.656.656,0,1,0,0-1.312Z",
    transform: "translate(-12.486 -5.366)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClockIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ClockIcon.2b7580a6.svg";
export { ForwardRef as ReactComponent };